import type { Region } from 'screens/OpenTableRegion/types';
import type { AgentSetupStep, OpenTableAgentConfig } from './types';

export const DEFAULT_OPEN_TABLE_AGENT_CONFIG: OpenTableAgentConfig = {
  agentName: '',
  voiceId: '',
  projectId: null,
  isNewProject: false,
  timezone: '',
  websiteUrl: '',
};

export const DEFAULT_PROVIDER_MODEL_ID = 'azure-oai-gpt-4o-mini';

export const BACK_STEP_MAP: Record<AgentSetupStep, AgentSetupStep | null> = {
  selectTimezone: null,
  websiteUrl: 'selectTimezone',
  selectAgent: 'websiteUrl',
  selectVoice: 'websiteUrl',
};

const DEFAULT_US_VOICES = [
  'lwFpi2nDK7eKOnGj6j32', // PolyVoice Erika
  'Owr3wktNf34NKcu7Gcmz', // Brian
  '8DzKSPdgEQPaK5vKG0Rs', // Vanessa
  '57hyqeGKP8M3BibjWwb3', // Natasha
  'DAgjOaO8Ats7rendsMe4', // Anne
  'cxWHwEz4DXPDpXKeQ2gc', // Troy
  'en-US-Neural2-G', // Female (US)
];

const DEFAULT_UK_VOICES = [
  'dTqqnmNMKYl0Y5SqbNOz', // Steven
  'Tx7VLgfksXHVnoY6jDGU', // Conversational Joe
  'ssHwp0KCFDTGtFbiUYl6', // John Smith
  'MIRXQ6kaSGUnvKewcGhZ', // Darren Walshe
  'rfkTsdZrVWEVhDycUYn9', // Shelby
  'HGZqbfi5WlHX1hIRDu95', // Opal
  'EdbfpG4MuVJNG3Wf27ce', // Shelly
  'VUejgZgnaYhpyrBaC7zM', // Ember
  'GZ3zQrAt2WDldEUul9JQ', // Ben
];

export const AVAILABLE_REGIONAL_VOICES: {
  [key in Region]: string[];
} = {
  'united-states': [...DEFAULT_US_VOICES],
  canada: [...DEFAULT_US_VOICES],
  'united-kingdom': [...DEFAULT_UK_VOICES],
  australia: [
    'LtPsVjX1k0Kl4StEMZPK', // Sophia
    // US-BACKUP
    ...DEFAULT_US_VOICES,
  ],
  ireland: [
    'jXL9qhD2NCIaHLhia8ex', // Laura
    'C92s6vssSLlabgIln1iY', // Michelle
    'tlKpUDfYaDGG10tLVOrH', // Shannon
    'sgk995upfe3tYLvoGcBN', // Labhaoise
    'e9SbiYL47FRd9onxuXHr', // Eanna
    // UK-BACKUP
    ...DEFAULT_UK_VOICES,
  ],
};

export const TIMEZONES: { [key in Region]: string[] } = {
  australia: [
    'Australia/Lord_Howe', // UTC +10:30, Lord Howe Island
    'Australia/Sydney', // UTC +10, Sydney / Melbourne / Canberra / Hobart
    'Australia/Brisbane', // UTC +10, Brisbane / Queensland (no DST)
    'Australia/Darwin', // UTC +9:30, Darwin / Northern Territory (no DST)
    'Australia/Adelaide', // UTC +9:30, Adelaide / South Australia
    'Australia/Perth', // UTC +8, Perth / Western Australia
  ],
  canada: [
    'America/St_Johns', // UTC -3:30, St. John's
    'America/Halifax', // UTC -4, Halifax
    'America/Toronto', // UTC -5, Toronto / Ottawa
    'America/Montreal', // UTC -5, Montreal
    'America/Winnipeg', // UTC -6, Winnipeg
    'America/Regina', // UTC -6, Regina / Saskatchewan (no DST)
    'America/Edmonton', // UTC -7, Calgary / Edmonton
    'America/Vancouver', // UTC -8 Vancouver
  ],
  ireland: [
    'Europe/Dublin', // UTC +0/+1, Dublin
  ],
  'united-kingdom': [
    'Europe/London', // UTC +0/+1, London
  ],
  'united-states': [
    'America/Puerto_Rico', // UTC -4, Puerto Rico (no DST)
    'America/New_York', // UTC -5, New York
    'America/Chicago', // UTC -6, Chicago
    'America/Denver', // UTC -7, Denver
    'America/Phoenix', // UTC -7, Phoenix (Mountain Time, no DST)
    'America/Los_Angeles', // UTC -8, Los Angeles / Vancouver
    'America/Anchorage', // UTC -9, Alaska
    'Pacific/Honolulu', // UTC -10, Hawaii
  ],
};
